<template>
  <div>
    <vertical>
      <page-header :items="headerItems" :title="'انتقال گروهی'" />

      <div class="card">
        <Section title="اطلاعات مالی">
          <div style="display: flex; flex-direction: column; gap: 2.2rem">
            <base-text disable v-model="mine" placeholder="انتقال از" title="انتقال از " />

            <combo-box
              required
              :searchedData="walletType"
              title="کیف پول"
              placeholder="کیف پول"
              :selectedValue="selectedWallet"
              @select="fillSelectedWallet"
              :inputStyle="comboStyle"
            />

            <base-text
              required
              v-model="model.amount"
              placeholder="مقدار انتقال"
              title="مقدار انتقال "
              secondTitle="به هر کاربر"
              :subLabel="`موجودی قابل برداشت (دادکوین) ${calculateRemainingStock && calculateRemainingStock > 0 ? calculateRemainingStock.toLocaleString() : 0}`"
            />
          </div>
        </Section>
      </div>

      <div class="card">
        <Section title="توضیحات">
          <TextAreaInput v-model="model.description" rows="3" class="__text_area" inputType="text" title="توضیحات تراکنش" />
        </Section>
      </div>

      <div class="card p-3">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <input
              v-click-outside="closeList"
              placeholder="جستجو"
              v-model="searchQuery"
              class="tableSearchInput"
              @input="updateSearchQuery(searchQuery)"
              @click="updateSearchQuery"
            />

            <div v-if="showUserList" class="scroll">
              <div class="user-list">
                <div class="d-flex position-relative item" v-for="(item, index) in list" :key="index" @click="addSelectedUser(item)">
                  <div class="user-image">
                    <img v-if="item.image" :src="item.image" />

                    <img v-else src="../../../assets/images/users/default.png" />
                  </div>

                  <div class="user">
                    <div class="name">
                      {{ item.fullName }}
                    </div>

                    <hr class="custom-hr" v-if="!item.fullName" />

                    <div class="phone">
                      {{ item.phone }}
                    </div>

                    <hr v-if="!item.phone" class="custom-hr" />

                    <div class="nationalCode">
                      {{ item.nationalCode }}
                    </div>

                    <hr v-if="!item.nationalCode" class="custom-hr" />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex gap-2">
            <input type="file" accept=".xlsx" ref="inputFile" @change="uploadExcel" class="excel-input" />

            <div class="upload-excel d-flex gap-2">
              <div @click="downloadExcelHandle" class="d-flex">
                <b-button variant="outline-primary">فایل نمونه</b-button>
              </div>

              <Button
                icon="fa-thin fa-file-excel"
                :loading="loading"
                class="mx-2 upload-btn"
                @click.native="openUploadBox"
                hasIcon
                text="بارگذاری فایل اکسل"
                btnClass="btn-border"
              />
            </div>
          </div>
        </div>

        <div style="height: 825px; overflow-y: auto" class="my-3">
          <table class="w-100">
            <thead v-if="userTable.length" class="table_head w-100">
              <tr>
                <td>#</td>

                <td>نام و نام خانوادگی</td>

                <td>تلفن</td>

                <td>وضعیت کاربران</td>

                <td></td>
              </tr>
            </thead>

            <tbody v-if="!userTable.length" style="height: 500px; overflow-y: scroll; position: relative">
              <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)">
                <div class="d-flex flex-column">
                  <p style="color: rgba(0, 0, 0, 1); text-align: center">موردی ثبت نشده است.</p>

                  <img src="../../../assets/images/exclamation-mark 1.svg" width="50" height="50" class="align-self-center" />
                </div>
              </div>
            </tbody>

            <tbody v-else>
              <tr v-for="(user, inx) in userTable" :key="inx">
                <td>
                  {{ inx + 1 }}
                </td>

                <td>{{ user.fullName }}</td>

                <td>{{ user.phone }}</td>

                <td>
                  <span :class="['status', { assigned_user: user.id }, { user_without_assign: !user.id }]">
                    {{ user.id ? 'ثبت نام شده' : 'ناموجود' }}
                  </span>
                </td>

                <td>
                  <i class="far fa-times-circle" style="font-size: 23px; font-weight: 100; cursor: pointer" @click="deleteUser(user)" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="d-flex flex-row-reverse gap-2 align-items-center">
        <b-button @click="onStartTransfer" :disabled="!userTable.length" variant="primary  px-5"> ثبت </b-button>

        <b-button @click="$router.push('/list/allbalancewithuserinfo')">انصراف</b-button>

        <div class="d-flex gap-2">
          <p class="remain_amount">موجودی باقی مانده (دادکوین)</p>

          <p :class="['remain_amount', { red_remain_amount: calculateRemainingStock <= 0 }]">
            {{ calculateRemainingStock && calculateRemainingStock > 0 ? calculateRemainingStock.toLocaleString() : 0 }}
          </p>
        </div>

        <p v-text="`تعداد کل کاربران ${userTable.length - calculateUnAssignedUsers.length}`" style="margin: 0 0.5rem; font-size: 16px" />
      </div>

      <toast :showToast="showToast" :error="error" :title="message" />
    </vertical>

    <b-modal id="warningModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="../../../assets/images/checked1.svg" />
        </div>

        <div class="error-title text-center">
          ادمین گرامی نسبت به افزایش کیف پول کاربران اطمینان لازم را داشته باشید در صورت واریز وجه در کیف پول کاربر، امکان برگشت از حساب وی وجود ندارد.
        </div>

        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center gap-1">
            <b-button class="ms-2 col-6 cancel_order" @click="$bvModal.hide('warningModal')" block>انصراف</b-button>

            <b-button class="col-6" variant="primary" block @click="onSubmit"> تایید واریز </b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="notificationModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <h5>لیست تراکنش های ناموفق کاربران</h5>

        <div style="height: 380px; overflow-y: auto">
          <table class="w-100">
            <thead v-if="userTable.length" class="table_head">
              <tr>
                <td>#</td>

                <td>نام و نام خانوادگی</td>

                <td>تلفن</td>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(user, inx) in userFailedTransferredFinance" :key="inx">
                <td>
                  {{ inx + 1 }}
                </td>

                <td>{{ user.fullName }}</td>

                <td>{{ user.phone }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center gap-1">
            <b-button class="ms-2 col-6 cancel_order" @click="$bvModal.hide('notificationModal')" block>انصراف</b-button>

            <b-button class="col-6" variant="primary" block @click="onTransferAgain"> تلاش مجدد جهت انتقال</b-button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="successModal" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="../../../assets/images/dadbanan/checkedItem.jpg" />
        </div>

        <div class="error-title text-center">انتقال وجه به کیف پول کاربران با موفقیت انجام شد و در جزییات تراکنش آن ها ثبت گردید.</div>

        <div class="mt-5 mb-3">
          <b-button
            class="col-6"
            style="background: rgba(52, 195, 143, 1); width: 100%; border-color: rgb(52, 195, 143)"
            block
            @click="$router.push({ path: '/list/allbalancewithuserinfo' })"
          >
            بازگشت به کیف پول
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Toast from '../../common/Toast.vue'
import Button from '../../common/Button.vue'
import Section from '../../common/form/Section.vue'
import vertical from '../../../layouts/vertical.vue'
import dadbananWallet from '../../../services/dadban/wallet'
import pageHeader from '../../layoutComponents/page-header.vue'
import dadbanUsersProvider from '../../../services/dadban/user'
import BaseText from '../../common/form/formModules/BaseText.vue'
import ComboBox from '../../common/form/formModules/ComboBox.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'

export default {
  components: { pageHeader, vertical, Section, BaseText, ComboBox, TextAreaInput, Button, Toast },
  data() {
    return {
      submit: false,
      model: {
        coin: '',
        userList: [],
        serviceName: '',
        description: '',
        amount: undefined,
        transactionType: 3,
      },
      headerItems: [
        {
          text: 'موجودی کیف پول کاربران',
          href: '/list/allbalancewithuserinfo',
        },
        {
          text: 'انتقال گروهی',
          active: true,
        },
      ],
      message: '',
      mine: 'خودم',
      error: false,
      userTable: [],
      loading: false,
      searchQuery: '',
      showToast: false,
      selectedWallet: '',
      failedTransfer: [],
      showUserList: false,
      walletInformation: {},
      userTransferredFinance: [],
      comboStyle: 'color: #495057',
      userFailedTransferredFinance: [],
      errorText: 'وارد کردن این فیلد الزامی است.',
      walletType: [{ value: 'دادکوین', key: 'DADCOIN' }],
    }
  },
  mounted() {
    this.fetchWallet()
  },
  watch: {
    'model.amount'(val) {
      this.model.amount = this.model.amount.toString()
      this.model.amount = val.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
  computed: {
    checkUnAssignedUsers() {
      let unAssignedUsers = []
      this.userTable.forEach((r) => {
        if (!r.id) return unAssignedUsers.push(r)
      })
      if (unAssignedUsers.length) return true
      else return false
    },
    calculateUnAssignedUsers() {
      return this.userTable.filter((r) => !r.id)
    },
    calculateRemainingStock() {
      if (!this.walletInformation.myBalances) return 0
      let _amount = this.model.amount ? this.model.amount.replace(/,/g, '') : 0
      const realUser = this.userTable.length - this.calculateUnAssignedUsers.length
      const transferAmount = Number(_amount)
      const totalTransferAmount = transferAmount * realUser
      return +this.walletInformation.myBalances.find((item) => item.coin === 'دادکوین').total - Number(totalTransferAmount)
    },
  },
  methods: {
    onStartTransfer() {
      if (this.calculateRemainingStock > 0) this.$bvModal.show('warningModal')
      else if (this.checkUnAssignedUsers) {
        this.showToast = false
        this.$nextTick(() => {
          this.error = true
          this.message = 'امکان افزایش موجودی کیف پول کاربرانیکه در سامانه ثبت نام نکرده اند وجود ندارد، ابتدا کاربران ناموجود را حذف نمایید '
          this.showToast = true
        })
        return
      } else {
        this.showToast = false
        this.$nextTick(() => {
          this.error = true
          this.showToast = true
          this.message = 'موجودی ناکافی می باشد .'
        })
      }
    },

    async onTransferAgain() {
      this.model.userList = []
      this.userFailedTransferredFinance.forEach((user) => this.model.userList.push({ userId: user.id }))
      try {
        const req = await dadbananWallet.chargeWalletWithTransferAdmin(this.model)
        this.userTransferredFinance = req.data.data
        this.failedTransfer = this.userTransferredFinance.filter((user) => user.isSuccessful)
        if (this.failedTransfer.length) {
          this.$bvModal.hide('warningModal')
          this.$bvModal.show('notificationModal')
          this.userTransferredFinance.forEach((user) => {
            const users = this.userTable.find((transfer) => user.userId === transfer.id)
            this.userFailedTransferredFinance.push(users)
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    async onSubmit() {
      if (!this.model.amount || !this.model.coin) {
        this.$bvModal.hide('warningModal')
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = true
          this.message = 'ادمین گرامی لطفا مقدار انتقال و مقدار کیف پول را صحیح وارد نمایید.'
        })

        return
      }
      let _amount = this.model.amount.replace(/,/g, '')

      this.userTable.forEach((user) => this.model.userList.push({ userId: user.id }))
      try {
        const req = await dadbananWallet.chargeWalletWithTransferAdmin({ ...this.model, amount: +_amount })
        this.userTransferredFinance = req.data.data
        this.failedTransfer = this.userTransferredFinance.filter((user) => user.isSuccessful)
        if (this.failedTransfer.length) {
          this.$bvModal.hide('warningModal')
          this.$bvModal.show('notificationModal')
          this.userTransferredFinance.forEach((user) => {
            const users = this.userTable.find((transfer) => user.userId === transfer.id)
            this.userFailedTransferredFinance.push(users)
          })
        } else {
          this.$bvModal.show('successModal')
        }
      } finally {
        this.$bvModal.hide('warningModal')
      }
    },
    async fetchWallet() {
      const result = await dadbananWallet.getAllBalanceInformation()
      if (result.status === 200) this.walletInformation = result.data.data
      else return
    },
    deleteUser(user) {
      this.userTable = this.userTable.filter((us) => us.phone !== user.phone)
    },
    fillSelectedWallet(e) {
      this.model.coin = this.walletType.find((type) => type.value === e).key
    },
    closeList() {
      this.showUserList = false
    },
    async updateSearchQuery() {
      try {
        const req = await dadbanUsersProvider.getSearchUsers(this.searchQuery ? `?keyword=${this.searchQuery || ''}&pageSize=100&pageNumber=1` : '?pageSize=100&pageNumber=1')

        this.list = req.data.data
        this.showUserList = true
      } catch (error) {
        console.log(error)
      }
    },
    async downloadExcelHandle() {
      window.open('https://utapg.cloudware.ir/filemanager/api/file/files/e55d553c-bae2-4e24-5659-08deb79dccc5', '_blank')
    },
    addSelectedUser(user) {
      const hasUser = this.userTable.find((item) => item.id === user.id)

      if (!hasUser && this.userTable.length >= 99) {
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = true
          this.message = 'ادمین گرامی امکان اضافه نمودن کاربران ، بیش از 100 نفر وجود ندارد.'
        })
      }
      if (!hasUser && this.userTable.length <= 99) {
        this.userTable.push({ ...user, createdDate: new Date().toISOString() })
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = false
          this.message = 'کاربر با موفقیت ثبت گردید.'
        })
      }
      if (hasUser) {
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = true
          this.message = 'کاربر پیش تر به لیست اضافه گردیده است .'
        })
      }
    },
    openUploadBox() {
      this.$refs.inputFile.click()
    },
    async uploadValidatedExcel(data) {
      const formData = new FormData()
      formData.append('file', data)
      try {
        this.loading = true
        const req = await dadbananWallet.addUsersExcel(formData)

        if (req.status === 200) {
          this.loading = false

          req.data.data.forEach((user) => {
            if (user.userId) return this.userTable.push({ fullName: `${user.firstName} ${user.lastName}`, phone: user.phoneNumber, id: user.userId })
            else return this.userTable.unshift({ fullName: `${user.firstName} ${user.lastName}`, phone: user.phoneNumber, id: user.userId })
          })

          this.$nextTick(() => {
            this.showToast = false
            this.error = false
            this.$refs.inputFile.value = ''
          })
          return false
        }
      } catch (error) {
        this.message = error.response.data.message
        this.error = true
        this.loading = false
        this.showToast = true
      } finally {
        this.loading = false
      }
      setTimeout(() => {
        this.showToast = false
        this.error = false
        this.$refs.inputFile.value = ''
      }, 5000)
    },
    uploadExcel(event) {
      const blob = event.target.files[0]
      if (!blob) return
      this.uploadValidatedExcel(blob)
    },
  },
}
</script>
<style lang="scss" scoped>
.__text_area {
  width: 100%;
  border-color: #ced4da;
  border-radius: 4px;
  padding: 6px 10px;
}
.tableSearchInput {
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  border-radius: 3px;
  outline: none;
  width: 450px;
  height: 27px;
}
.tableSearchInput::placeholder {
  padding: 0 12px;
}

.scroll {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  height: 220px;
  width: 450px;
  padding-left: 0;
  position: absolute;
  margin-top: 5px;
  z-index: 100;
}
.user-list {
  overflow-y: auto;
  height: 170px;
}
.item {
  padding: 15px 10px;

  &:hover {
    background: rgba(85, 110, 230, 0.1);
  }
}
.user-image {
  img {
    width: 28px;
    height: 28px;
    border-radius: 100%;
  }
}

.user {
  display: flex;
  width: 100%;
  justify-content: center;
  cursor: pointer;

  .name {
    position: relative;
    top: 5px;
    margin-right: 10px;
    width: 50%;
  }

  .phone,
  .nationalCode {
    width: 25%;
    color: #999696;
    text-align: center;
    margin-right: 50px;
    position: relative;
    top: 5px;
  }
}

.custom-hr {
  margin: 0 !important;
  bottom: 10px;
  position: relative;
  top: 13px;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  width: 50px;
  left: 30px;
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

.excel-input {
  width: 0;
  height: 0;
}

.table_head {
  background-color: #f8f9fa;
  td {
    padding: 12px;
    font-size: 14px;
  }
}

::v-deep .secondLabelStyle {
  color: #444444;
  opacity: 0.3;
}

::v-deep .subLabelStyle {
  color: rgb(44 225 212);
}

.table_head {
  background-color: #f8f9fa;
  td {
    padding: 12px;
    font-size: 14px;
  }
}

.td {
  padding: 12px;
  font-size: 14px;
  font-weight: bold;
}

tbody {
  td {
    padding: 18px;
    border-bottom: 1px solid rgb(248, 239, 239);
  }
}

tbody tr:last-child td {
  border-bottom: none;
}

.status {
  border-radius: 5rem;
  padding: 0.2rem 1rem;
}

.assigned_user {
  color: rgba(52, 195, 143, 1);
  background-color: rgba(218, 244, 235, 1);
}

.user_without_assign {
  color: rgba(244, 106, 106, 1);
  background-color: rgba(244, 106, 106, 0.18);
}

.remain_amount {
  margin: 0;
  font-size: 16px;
}

.red_remain_amount {
  font: bolder;
}

::v-deep .modal-header {
  width: 47rem !important;
}
</style>
